import { Suspense } from 'react';
import { ISearchDetailsListProps } from './SearchDetailsList/searchList';
import {
  SearchDetailsListShimmer,
  ISearchDetailsListShimmerProps,
} from './ShimmerList';
import { LazySearchDetailsList } from './LazySearchDetailsList';

export { useSearchListData } from './SearchDetailsList/SearchListContext';

/**
 * This is a self-contained list component that provides column selection,
 * filtering, sorting, and grouping.
 */
export const SearchDetailsList = <T,>(props: ISearchDetailsListProps<T>) => (
  <Suspense
    fallback={
      <SearchDetailsListShimmer
        filterCount={props?.filterElementList?.length}
        columns={props?.allColumnList}
        tableName={props?.tableName}
      />
    }
  >
    <LazySearchDetailsList {...props} />
  </Suspense>
);

export type { ISearchDetailsListShimmerProps };
export { SearchDetailsListShimmer };
